module.exports = __webpack_public_path__ + "img/atari1200_front.fb067801.jpg";